import { render, staticRenderFns } from "./userPanel.vue?vue&type=template&id=8b6cac38&"
import script from "./userPanel.vue?vue&type=script&lang=js&"
export * from "./userPanel.vue?vue&type=script&lang=js&"
import style0 from "./userPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports